import { getProductLineId, getProductId } from './../../order-builder/modules/specification/helpers/product.helper';
import { Injectable } from '@angular/core';
import { PlantsService, PlantsRequest } from '@cemex-core/cmx-api';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { State } from '../reducers';
import { getOneClickState, OneClickState } from './../reducers/index';
import {
  OneClickPlantsActionTypes,
  OneClickLoadPlantsCompleteAction,
  OneClickLoadPlantsAction,
} from '../actions/one-click-plants.actions';

@Injectable()
export class OneClickPlantsEffects {
  oneClickPlants$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickPlantsActionTypes.LOAD_PLANTS),
      switchMap((action: OneClickLoadPlantsAction) =>
        this.store.select(getOneClickState).pipe(
          take(1),
          map((state) => {
            return { state, index: action.index };
          }),
        ),
      ),
      map(({ state, index }) => {
        return {
          request: this.makePlantsRequestFromState(state, index),
          index: index,
        };
      }),
      switchMap(({ request, index }) =>
        this.plantService.getPlants(request).pipe(
          map((response) => {
            return {
              response,
              index,
            };
          }),
        ),
      ),
      map(({ response, index }) => new OneClickLoadPlantsCompleteAction(response.plants, index)),
    ),
  );

  private makePlantsRequestFromState(state: OneClickState, index = 0): PlantsRequest {
    return {
      countryCode: state.shippingMethodsState.selected.countryCode,
      shippingConditionId: state.shippingMethodsState.selected.shippingConditionId,
      productLineId: getProductLineId(state.productsState.selected[index]),
      productId: `${getProductId(state.productsState.selected[index])}`,
    } as PlantsRequest;
  }

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private plantService: PlantsService,
  ) {}
}
